export const PROJECTDESCRIPTION_CHANGESET_ITEM_KEY = 'PROJECTDESCRIPTION_CHANGESET_ITEM';
export const PROJECTDESCRIPTION_CHANGESET_ITEM_NAME = 'About Project';
export const VARIABLE_CHANGESET_ITEM_KEY = 'VARIABLE_CHANGESET_ITEM';
export const VARIABLE_CHANGESET_ITEM_NAME = 'Variables';
export const BUNDLE_CHANGESET_ITEM_KEY = 'BUNDLE_CHANGESET_ITEM';
export const BUNDLE_CHANGESET_ITEM_NAME = 'Pattern Libraries';
